<template>
  <div>
    <indexHeader ref="indexHeader"></indexHeader>
    <div class="check load_inLeft">
      <div class="status">
        <div class="qrcode_box" id="qrCode" ref="qrCodeDiv" v-show="fr == '0'">
          <!-- <img v-if="fr != '1'" :src="`data:image/png;base64,${QRCode}`" width="160px" height="160px" /> -->
        </div>
        <div class="qrcode_box" id="qrCode2" ref="qrCodeDiv2" v-show="fr == '2'">
          <!-- <img v-if="fr != '1'" :src="`data:image/png;base64,${QRCode}`" width="160px" height="160px" /> -->
        </div>
        <div v-if="fr == '1'">
          <img src="/static/images/new/zf_wc.png" alt="">
        </div>
        <div v-if="zfzt == 1" style="font-size: 20px;font-weight: 500;color: #202331;margin-top: 20px;">支付成功</div>
        <p v-if="fr == '1'" style="color: #777C94;">
          <span style="color: #2287FF;">法定代表人</span>请直接去参训或授权企业中其他人参训
        </p>
        <p v-else-if="fr == '2'" style="color: #777C94;">
          <span style="color: #2287FF;">法定代表人</span>自己参训需要先扫码进行实人认证
        </p>
        <p v-else style="color: #777C94;">
          <span style="#2287FF">您不是法定代表人</span>，打开微信扫描上方二维码去申请授权
        </p>
        <div v-if="fr == '1'">
          <div class="back" @click="sqtr()">授权其他人</div>
          <div class="join" @click="brpx()">法人参训</div>
        </div>
        <div v-else>
          <!-- <div class="back" @click="applyAction()">申请授权</div> -->
          <div class="back_re" @click="goBackIndex">返回首页</div>
        </div>
      </div>
    </div>

    <indexFooter></indexFooter>
  </div>
</template>

<script>
import { cookie } from "@/common/js/cookies.js";
import indexHeader from "@/components/index/index_header";
import indexFooter from "@/components/index/index_footer";
import QRCode from "qrcodejs2";
export default {
  name: "index_yzf",
  data() {
    return {
      fr: 0,
      qyPxzt: 1,
      QRCode: "",
      urlParam: "",
      pxrId: "",
      qyId: "",
      lxId: "",
      kcId:null,  //课程id
      timer:null,  //定时器开关
	  zfzt:null,  //支付状态
    };
  },
  created() {
    this.kcId = this.$route.query.kcId;
    // 自动跳转流程
    let { sign } = this.$route.query;
    if (sign == 1) {
      let NEXT_DO_OBJ = JSON.parse(localStorage.getItem("NEXT_DO_OBJ"));
      this.lxId = NEXT_DO_OBJ.lxId;
      // 赋值后删除
      // localStorage.removeItem("NEXT_DO_OBJ");
    }else{
      this.lxId = this.$route.query.lxId;
    }
    this.getUserQy();
  },
  mounted() {
    document.getElementsByClassName("header")[0].style.background = "#fff";
    // 定时器
    this.timer = setInterval(() => {
      this.getUserKC();
    },2000)
  },
  beforeDestroy() {
    if(this.timer){
      clearInterval(this.timer);
    }
  },
  components: {
    indexHeader,
    indexFooter,
  },
  methods: {
    //生成二维码
    bindQRCode: function () {
      console.log(QRCodeUrl + this.urlParam)
      new QRCode(this.$refs.qrCodeDiv, {
        text: QRCodeUrl + this.urlParam,
        width: 160,
        height: 160,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },
    goBackIndex() {
      this.$router.push("/");
    },
    applyAction() {
      this.$message({
        showClose: true,
        message: "亲,当前授权操作只能在手机微信端才能操作哟!",
        type: "info",
      });
    },
    sqtr() {
      let _self = this;
      this.$confirm(
        "确认授权他人参训？（授权周期默认30天，请在30天内完成培训）",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let ajax = _self.$http.create();
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          ajax({
            method: "post",
            url: SOWINURL + "index/startAuthorize",
            data: {
              period: 30,
              verifyMethod: "picFace", // picFace：负责人人脸识别验证，cert：法人数字证书验证，elicense：电子营业执照验证，
            },
            headers: {
              token: cookie.get("xyxf_token_qt"),
            },
          })
            .then(function (json) {
              // console.log(json.data);
              if (json.data.result == 1) {
                // _self.$message({
                //   showClose: true,
                //   message: '操作成功！',
                //   type: 'success'
                // });
                window.location.href = json.data.data.sqUrl;
                // _self.$router.push('/index');
              } else {
                _self.$message({
                  showClose: true,
                  message: json.data.errorcode,
                  type: "error",
                });
                if (json.data.errorcode.indexOf("实名") > -1) {
                  _self.$parent.$refs["indexHeader"].$refs[
                    "smrz"
                  ].drawer = true;
                }
              }
              loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    brpx() {
      let _self = this;
      this.$confirm("确认本人参训？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let formdata1 = new FormData();
        formdata1.append("lxId", _self.lxId);
        formdata1.append("qyId", _self.qyId);
          let ajax = _self.$http.create();
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          ajax({
            method: "post",
            url: SOWINURL + "index/brpx",
            headers: {
              token: cookie.get("xyxf_token_qt"),
            },
            data: formdata1,
          })
            .then(function (json) {
              console.log(json.data);
              if (json.data.result == 1) {
                // _self.$message({
                //   showClose: true,
                //   message: "操作成功！即将跳转至下一步",
                //   type: "success",
                // });
                // setTimeout(function () {
                //   window.location.href = "/courseDetail?sign=1&lxId="+ _self.$route.query.lxId+'&qyId='+_self.$route.query.qyId;
                // }, 1000);
                loading.close();
                _self.fr = 2;
                new QRCode(_self.$refs.qrCodeDiv2, {
                  text: json.data.data,
                  width: 160,
                  height: 160,
                  colorDark: "#333333", //二维码颜色
                  colorLight: "#ffffff", //二维码背景色
                  correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
                });
              } else {
                _self.$message({
                  showClose: true,
                  message: json.data.errorcode,
                  type: "error",
                });
                if (json.data.errorcode.indexOf("实名") > -1) {
                  _self.$parent.$refs["indexHeader"].$refs[
                    "smrz"
                  ].drawer = true;
                }
              }
              loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    // 一直刷新的是true就跳转 不是就继续刷 定时器
    getUserKC: function () {
      let _self = this;
	  let kcId='';
	  if(_self.kcId){
		  kcId= '&kcId='+_self.kcId;
	  }
      let ajax = _self.$http.create();
      ajax({
        method: "get",
        url: SOWINURL + "XxKh/authresult?"+'lxId='+_self.$route.query.lxId+kcId,
        headers: {
          token: cookie.get("xyxf_token_qt"),
        },
      })
        .then(function (res) {
        if(res.data.result == 1){
          if(res.data.data){
              _self.$router.push({
                path: "/courseDetail",
                query: {
                  lxId: _self.$route.query.lxId,
                  kcId: _self.$route.query.kcId,
                  qyId: _self.$route.query.qyId,
                },
              })

            clearInterval(_self.timer);
          }
        }
          // loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getUserQy: function (callback) {
      //获取用户企业列表
      let _self = this;
      let ajax = _self.$http.create();
      ajax({
        method: "get",
        url: SOWINURL + "index/getUserQy",
        headers: {
          token: cookie.get("xyxf_token_qt"),
        },
      })
        .then(function (res) {
          let resData = res.data;
          if (resData.result == 1) {
            let userData = resData.data;
            _self.fr = userData.sfQyfr;
            _self.qyPxzt = userData.qyPxzt;
            _self.pxrId = userData.pxrId;
            _self.qyId = userData.qyId;
            _self.zfzt = userData.qyZfzt;
            _self.getQRCode();
          }
          // loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //获取授权二维码
    getQRCode: function () {
      let _self = this;
      let formdata1 = new FormData();
      formdata1.append("userId", _self.pxrId);
      formdata1.append("qyId", _self.qyId);

      let ajax = _self.$http.create();
      ajax({
        method: "post",
        url: SOWINURL + "index/getAuthorizationURL",
        headers: {
          token: cookie.get("xyxf_token_qt"),
        },
        data: formdata1,
      })
        .then(function (json) {
          // console.log(json.data.result);
          if (json.data.result == 200) {
            let qrData = json.data.data;
            // _self.QRCode = qrData.qrCodeBase64;
            let token = cookie.get("xyxf_token_qt");
            let urlParam = `?userId=${_self.pxrId}&qyId=${_self.qyId}&token=${token}`;
            _self.urlParam = urlParam;
            _self.$nextTick(function () {
              _self.bindQRCode();
            });
          }
          // loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

  },
};
</script>

<style scoped lang="less" type="text/less">
.status {
  width: 1210px;
  margin: 20px auto;
  padding-top: 130px;
  background: #fff;
  text-align: center;
  padding-bottom: 200px;
  .tx {
    text-align: center;
    span {
      display: inline-block;
      font-size: 14px;
      color: #0076ff;
      margin: 0 20px;
    }
  }
  .back {
  	width: 210px;
  	height: 45px;
  	border-radius: 8px;
  	border: 1px solid rgba(0, 134, 255, 0.69);
  	// background: #2287FF;
  	text-align: center;
  	color: #0086FF;
  	line-height: 45px;
  	display: inline-block;
  	margin-right: 10px;
  	cursor: pointer;
  	margin-top: 100px;
  }
  .join {
    width: 210px;
    height: 45px;
    border: 1px solid rgba(117, 208, 135, 0.69);
    border-radius: 8px;
    color: #3BBD6A;
    line-height: 45px;
    text-align: center;
    display: inline-block;
  	 cursor: pointer;
  	 margin-top: 100px;

}
.back_re{
	width: 210px;
	height: 45px;
	border: 1px solid rgba(0, 134, 255, 0.69);
	border-radius: 8px;
	color: #2287FF;
	line-height: 45px;
	text-align: center;
	display: inline-block;
	 cursor: pointer;
	 margin-top: 100px;
}

  img {
    display: block;
    margin: 0 auto;
  }

  h3 {
    height: 90px;
    line-height: 90px;
    text-align: center;
    font-size: 30px;
    color: #02113a;
  }

  p {
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 16px;
    color: #070d4b;
    span {
      // font-weight: bold;
    }
    /*margin-bottom: 100px;*/
  }
}
.exam {
  padding: 50px 100px;
  background: #fff;
  margin-bottom: 20px;
}
.qrcode_box {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  border-radius: 10px;
  border: 1px solid #0374ff;
  padding: 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index_yzf.vue